import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  fullWidth = false,
  className = '',
  scrollTo,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-sans font-bold tracking-wide transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold';
  const variants = {
    primary: 'bg-gold text-white hover:bg-gold-dark shadow-[0_4px_14px_0_rgba(201,169,110,0.39)]',
    secondary: 'bg-brown text-cream hover:bg-brown-dark shadow-[0_4px_14px_0_rgba(61,43,31,0.39)]',
    outline: 'border-2 border-gold text-brown hover:bg-gold hover:text-white'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    props.onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} onClick={handleClick} data-id="element-214">
      {children}
    </motion.button>;
}